import { render, staticRenderFns } from "./DirectionRoseChart.vue?vue&type=template&id=049828c8&"
import script from "./DirectionRoseChart.vue?vue&type=script&lang=js&"
export * from "./DirectionRoseChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports